<template>
  <DDR :active="item.active" :draggable="item.draggable" :rotatable="item.rotatable" :minWidth="item.minWidth"
    :minHeight="item.minHeight" :key="item.id" :id="item.id" :acceptRatio="item.acceptRatio" :parent="item.parent ? item.parent : false" :axis="'xy'"
    v-model="item.transform" :beforeActive="beforeActiveLayer" :renderContent="renderElementLayer"
    @resizeend="handleResize" @rotateend="handleRotate" @dragend="handleDrag" @resizestart="handleResizeStart">
  </DDR>
</template>
<script>

import DDR from 'yoyoo-ddr'
import 'yoyoo-ddr/dist/yoyoo-ddr.css'
import { ActionEditor, TypeChooseLayer, TypePlayList } from '../../constant';

export default {
  name: 'Draggable',
  components: { DDR },
  props: ['item'],
  data: function () {
    return {
      loading: { value: false },
      actionEditor: ActionEditor,
      typeChooseLayer: TypeChooseLayer,
      typeLayer: null,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handleDrag(event, transform) {
      this.transform = transform;
    },
    handleResizeStart(event, transform) {
      this.transform = transform;
    },
    handleResize(event, transform) {
      this.transform = transform;
    },
    handleRotate(event, transform) {
      this.transform = transform;
    },
    beforeActiveLayer() {
      this.$emit('active:layer', this.item);
    },
    renderElementLayer() {
      if (this.item.extractData && (this.item.extractData.typeLayer != null && this.item.extractData.typeLayer != undefined)) {
        var item = this.item;
        var attr = item.attr;
        var data = item.extractData;
        var transform = item.transform
        var _style;
        var _styleWrapper;
        switch (this.item.extractData.typeLayer) {
          case this.typeChooseLayer.TEXT: {
            if (this.item.extractData.isRun === true) {     /* Xử lý chữ chạy với loại văn bản */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
              return <div class="scroll-left" style={_styleWrapper}><p class="marquee"
                style={_style}>{data.content.trim()}</p></div>;
            } else {
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              return <div style={_style}>{data.content}</div>
            }
          }
          case this.typeChooseLayer.IMAGE: {
            _style = `width:100%;height:100%`;
            return <img src={data.url} alt={data.url} style={_style} />
          }
          case this.typeChooseLayer.VIDEO: {
            // _style = `width:${transform.width}px;height:${transform.height}px`;
            _style = `width:100%;height:100%`;
            return <img src={data.urlThumbnail} alt={data.urlThumbnail} style={_style} />
          }
          case this.typeChooseLayer.STREAM_VTV: {
            _style = `width:100%;height:100%`;
            return <img src={data.urlThumbnail} alt={data.urlThumbnail} style={_style} />
          }
          case this.typeChooseLayer.PLAY_LIST: {
            // _style = `width:${transform.width}px;height:${transform.height}px`;
            _style = `width:100%;height:100%`;
            if (data.type === TypePlayList.TEXT_RUN) {    /* Playlist loại văn bản gồm chữ chạy và chữ thường */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
              var _content = '';
              data.playListDetailModels.map(each => {
                if (each.content) {
                  _content = _content.concat(each.content + " ");
                }
              });
              return <div class="scroll-left" style={_styleWrapper}><p class="marquee"
                style={_style}>{_content.trim()}</p></div>;
            } else if (data.type === TypePlayList.TEXT_NORMAL) {
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              return <div style={_style}>{data.playListDetailModels[0].content}</div>
            } else if (data.type === TypePlayList.IMAGE) {    /* PlayList loại media gồm hình ảnh và video */
              return <img src={data.playListDetailModels[0].url} alt={data.playListDetailModels[0].url}
                style={_style} />
            } else if (data.type === TypePlayList.VIDEO) {
              return <img src={data.playListDetailModels[0].urlThumbnail}
                alt={data.playListDetailModels[0].urlThumbnail}
                style={_style} />
            } else if (data.type === TypePlayList.DOCUMENT) {
              return <img src={data.playListDetailModels[0].urlImagesDoc[0]} alt={data.playListDetailModels[0].urlImagesDoc[0]}
                style={_style} />
            }
            break;
          }
          case this.typeChooseLayer.YOUTUBE: {
            // _style = `width:${transform.width}px;height:${transform.height}px`;
            _style = `width:100%;height:100%`;
            return <img src={data.img} alt={data.img} style={_style} />
          }
          case this.typeChooseLayer.RSS: {
            _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
            _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
            var content = '';
            for (var i = 0; i < 10; i++) {
              content += data.itemRss[i].title + " : " + data.itemRss[i].description.replace(/<[^>]*>?/gm, '')
                .replace(/\u00a0/g, " ").replace(/\s/g, " ").replace(/\xA0/g, " ").replace(/&#160;/g, ' ') + " ";
            }
            return <div class="scroll-left" style={_styleWrapper}>
              <p class="marquee" style={_style}>{content}</p>
            </div>;
          }
          case this.typeChooseLayer.DOCUMENT: {
            // _style = `width:${transform.width}px;height:${transform.height}px`;
            _style = `width:100%;height:100%`;
            return <img src={data.itemsImage[0]} alt={data.itemsImage[0]} style={_style} />
          }

          case this.typeChooseLayer.AREA_TEXT: {
            if (item.isSlideShow) {
              if (data.isRun === true) {
                _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
                _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
                return <div class="scroll-left" style={_styleWrapper}>
                  <p class="marquee" style={_style}>{data.content.trim()}</p></div>;
              } else {
                _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
                return <div style={_style}>{data.content}</div>
              }
            } else {
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${transform.height}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              return <div style={_style}>Vùng văn bản</div>
            }
          }
          case this.typeChooseLayer.AREA_LEFT: {
            if (item.isSlideShow) {
              // _style = `width:${transform.width}px;height:${transform.height}px`;
              _style = `width:100%;height:100%`;
              return this.generateArea(data, _style)
            } else {
              _style = `height:${transform.height}px;line-height:${transform.height}px;background:gray;text-align:center;color:white;font-size:30px;font-weight:bold`;
              return <div style={_style}>Vùng trái</div>
            }
          }
          case this.typeChooseLayer.AREA_RIGHT: {
            if (item.isSlideShow) {
              // _style = `width:${transform.width}px;height:${transform.height}px`;
              _style = `width:100%;height:100%`;
              return this.generateArea(data, _style)
            } else {
              _style = `height:${transform.height}px;line-height:${transform.height}px;background:#e5d4d4;text-align:center;color:white;font-size:30px;font-weight:bold`;
              return <div style={_style}>Vùng phải</div>
            }
          }
          case this.typeChooseLayer.FULL_SCREEN: {
            if (item.isSlideShow) {
              // _style = `width:${transform.width}px;height:${transform.height}px`;
              _style = `width:100%;height:100%`;
              return this.generateArea(data, _style)
            } else {
              // _style = `width:${transform.width}px;height:${transform.height}px`;
              _style = `width:100%;height:100%`;
              return <img src="../../../static/img/sample-img.jpg" alt="" style={_style} />
            }
          }
          case this.typeChooseLayer.WIDGET: {
            // _style = `width:${transform.width}px;height:${transform.height}px`;
            _style = `width:100%;height:100%`;
            // new Function(data.script)();
            setTimeout(function () {
              new Function(data.script)();
            })
            return h("div", {domProps:{innerHTML: data.html}, style: {_style}})
          }
        }
      }
    },
    generateArea(data, style) {
      if (data.type == TypePlayList.IMAGE) {
        return <img src={data.url} alt={data.url} style={style} />
      } else if (data.type == TypePlayList.VIDEO) {
        return <img src={data.urlThumbnail} alt={data.urlThumbnail} style={style} />
      }
    }
  },
  watch: {},
  destroyed() {
  }
}
</script>

<style scoped>
video {
  object-fit: cover;
}

.scroll-left {
  overflow: hidden;
  position: relative;
}

.marquee {
  display: inline-block;
  white-space: nowrap;
  /*animation: scrollLeft 70s linear infinite;*/
  padding-left: 101%;
  line-height: 50px;
  text-align: center;
  margin: unset;
}
</style>

